<div class="wrapper" [ngStyle]="styling.height()">
    <div class="header">
        <ng-content select="[list-header]"></ng-content>
    </div>

    <ng-content select="[list-content]"></ng-content>
</div>
